export default "__VITE_ASSET__Dc01cP1W__"